import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import {
   IntegerField_FragmentFragmentDoc,
   FloatField_FragmentFragmentDoc,
   EmailField_FragmentFragmentDoc,
   FileUploaderField_FragmentFragmentDoc,
   LongTextField_FragmentFragmentDoc,
   PlainTextField_FragmentFragmentDoc,
   ShortTextField_FragmentFragmentDoc,
   UrlField_FragmentFragmentDoc,
   TimeField_FragmentFragmentDoc,
   DateField_FragmentFragmentDoc,
   DateTimeField_FragmentFragmentDoc,
   DropdownField_FragmentFragmentDoc,
   MultiSelectField_FragmentFragmentDoc,
   CheckboxGroupField_FragmentFragmentDoc,
   RadioGroupField_FragmentFragmentDoc,
   PhoneNumberField_FragmentFragmentDoc,
   FieldsSelectorField_FragmentFragmentDoc,
   RelationField_FragmentFragmentDoc,
   GeoLocationField_FragmentFragmentDoc,
   GeoShapeField_FragmentFragmentDoc,
   FieldNotFound_FragmentFragmentDoc,
   NotPermittedField_FragmentFragmentDoc,
   FieldIsDeleted_FragmentFragmentDoc
} from '@flowwai-frontend/bps-officer-web/graphql-docs'
import * as Apollo from '@apollo/client'
export type GetSearchAndMonitoringConfigQueryVariables = Types.Exact<{
   [key: string]: never
}>

export type GetSearchAndMonitoringConfigQuery = {
   __typename?: 'Query'
   getSearchAndMonitoringConfig:
      | {
           __typename?: 'GetSearchAndMonitoringConfigResult'
           overviewFieldIds: Array<string>
           fields: Array<{
              __typename?: 'SearchAndMonitoringFieldConfig'
              fieldId: string
              name: string
              fieldType: Types.ApplicationPropertyType
              options?: Array<string | null> | null
              parentFieldId?: string | null
              dependentOptions?: {
                 __typename?: 'SearchAndMonitoringFieldDependentOptionsConfig'
                 parentFieldId: string
                 optionsMappings: Array<{
                    __typename?: 'SearchAndMonitoringFieldDependentOptionMapping'
                    parentFieldOption: string
                    dependentOptions: Array<string>
                 }>
              } | null
              optionConfigs: Array<{
                 __typename?: 'SearchAndMonitoringOptionConfig'
                 option: string
                 pipelineItemTemplateId: string
              }>
              pipelineItemTemplateFields: Array<{
                 __typename?: 'SearchAndMonitoringPipelineItemTemplateField'
                 pipelineItemTemplateId: string
                 field:
                    | {
                         __typename?: 'CheckboxGroupField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         options: Array<string>
                         iconId?: string | null
                         multiStringDefaultValue: Array<string>
                      }
                    | {
                         __typename?: 'DateField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         iconId?: string | null
                         dateFieldDefaultValue?: string | null
                         relativeDefaultValueConfig?: {
                            __typename?: 'DateRelativeDefaultValueConfig'
                            operator: Types.ArithmeticOperation
                            noOfDays: number
                            DateValueEnum: Types.DateValueEnum
                         } | null
                      }
                    | {
                         __typename?: 'DateTimeField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         iconId?: string | null
                         dateTimeDefaultValue?: string | null
                         relativeDefaultValueConfig?: {
                            __typename?: 'DateTimeRelativeDefaultValueConfig'
                            dateConfig?: {
                               __typename?: 'DateRelativeDefaultValueConfig'
                               operator: Types.ArithmeticOperation
                               noOfDays: number
                               DateValueEnum: Types.DateValueEnum
                            } | null
                            timeConfig?: {
                               __typename?: 'TimeRelativeDefaultValueConfig'
                               operator: Types.ArithmeticOperation
                               noOfSeconds: number
                               TimeValueEnum: Types.TimeValueEnum
                            } | null
                         } | null
                      }
                    | {
                         __typename?: 'DropdownField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         options: Array<string>
                         isLabelsEnabled: boolean
                         iconId?: string | null
                         dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
                         allowOtherOptions: boolean
                         stringDefaultValue?: string | null
                         conditionalOptions: Array<{
                            __typename?: 'ConditionalFieldOptions'
                            parentFieldId: string
                            options: Array<{
                               __typename?: 'ConditionalOptions'
                               parentFieldOption: string
                               options: Array<string>
                            }>
                         }>
                         optionColors: Array<{
                            __typename?: 'OptionColorConfig'
                            option: string
                            color: Types.ColorEnum
                         }>
                      }
                    | {
                         __typename?: 'EmailField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         regexErrorMessage?: string | null
                         validationRegex?: string | null
                         isUnique: boolean
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
                    | {
                         __typename?: 'FieldsSelectorField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         options: Array<string>
                         systemFieldEnum?: Types.SystemFieldEnum | null
                         iconId?: string | null
                         fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
                         fieldSelectorFieldDefaultValue?: string | null
                         dependentFields: Array<{
                            __typename?: 'DependentFields'
                            option: string
                            dependentFieldIds: Array<string>
                         }>
                      }
                    | {
                         __typename?: 'FileUploaderField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         allowedFormats: Array<string>
                         maxNumberOfFilesToUpload: number
                         eachFileMaxSizeInKb: number
                         canDownload: boolean
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
                    | {
                         __typename?: 'FloatField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         isUnique: boolean
                         isFormulaEnabled: boolean
                         iconId?: string | null
                         floatDefaultValue?: number | null
                         rangeConfig?: {
                            __typename?: 'FloatRangeConfig'
                            floatMinValue?: number | null
                            floatMaxValue?: number | null
                         } | null
                      }
                    | {
                         __typename?: 'GeoLocationField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         systemFieldEnum?: Types.SystemFieldEnum | null
                         addressFieldIds: Array<string>
                         iconId?: string | null
                      }
                    | {
                         __typename?: 'GeoShapeField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         systemFieldEnum?: Types.SystemFieldEnum | null
                         variantType: Types.GeoShapeVariantType
                         addressFieldIds: Array<string>
                         iconId?: string | null
                      }
                    | {
                         __typename?: 'IntegerField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         isUnique: boolean
                         isFormulaEnabled: boolean
                         iconId?: string | null
                         intDefaultValue?: number | null
                         rangeConfig?: {
                            __typename?: 'IntegerRangeConfig'
                            intMinValue?: number | null
                            intMaxValue?: number | null
                         } | null
                      }
                    | {
                         __typename?: 'LongTextField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         isFormulaEnabled: boolean
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
                    | {
                         __typename?: 'MultiSelectField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         options: Array<string>
                         isLabelsEnabled: boolean
                         iconId?: string | null
                         multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
                         allowOtherOptions: boolean
                         multiStringDefaultValue: Array<string>
                         conditionalOptions: Array<{
                            __typename?: 'ConditionalFieldOptions'
                            parentFieldId: string
                            options: Array<{
                               __typename?: 'ConditionalOptions'
                               parentFieldOption: string
                               options: Array<string>
                            }>
                         }>
                         optionColors: Array<{
                            __typename?: 'OptionColorConfig'
                            option: string
                            color: Types.ColorEnum
                         }>
                      }
                    | {
                         __typename?: 'PhoneNumberField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         isUnique: boolean
                         iconId?: string | null
                      }
                    | {
                         __typename?: 'PlainTextField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         regexErrorMessage?: string | null
                         validationRegex?: string | null
                         systemFieldEnum?: Types.SystemFieldEnum | null
                         isUnique: boolean
                         isFormulaEnabled: boolean
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
                    | {
                         __typename?: 'RadioGroupField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         options: Array<string>
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
                    | { __typename?: 'RelationField' }
                    | {
                         __typename?: 'ShortTextField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         regexErrorMessage?: string | null
                         validationRegex?: string | null
                         systemFieldEnum?: Types.SystemFieldEnum | null
                         isFormulaEnabled: boolean
                         iconId?: string | null
                         stringDefaultValue?: string | null
                         prefixOptions?: {
                            __typename?: 'PrefixOptions'
                            isEnabled: boolean
                            values: Array<string>
                            optionsValueType: Types.OptionsValueType
                            conditionalPrefixOptions: Array<{
                               __typename?: 'ConditionalFieldOptions'
                               parentFieldId: string
                               options: Array<{
                                  __typename?: 'ConditionalOptions'
                                  options: Array<string>
                                  parentFieldOption: string
                               }>
                            }>
                         } | null
                         suffixOptions?: {
                            __typename?: 'SuffixOptions'
                            isEnabled: boolean
                            values: Array<string>
                         } | null
                      }
                    | {
                         __typename?: 'TimeField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         iconId?: string | null
                         timeFieldDefaultValue?: string | null
                         relativeDefaultValueConfig?: {
                            __typename?: 'TimeRelativeDefaultValueConfig'
                            operator: Types.ArithmeticOperation
                            noOfSeconds: number
                            TimeValueEnum: Types.TimeValueEnum
                         } | null
                      }
                    | {
                         __typename?: 'URLField'
                         fieldId: string
                         permissionType: Types.PermissionType
                         gofId: string
                         salesTemplateId: string
                         name: string
                         description?: string | null
                         fieldType?: Types.FieldType | null
                         isRequired: boolean
                         helpText?: string | null
                         tooltip?: string | null
                         placeholderText?: string | null
                         regexErrorMessage?: string | null
                         validationRegex?: string | null
                         isUnique: boolean
                         alternateDisplayText?: string | null
                         iconId?: string | null
                         stringDefaultValue?: string | null
                      }
              }>
           }>
           filterFields: Array<{
              __typename?: 'SearchAndMonitoringFilterField'
              fieldId: string
              operators: Array<Types.FilterOperator>
           }>
        }
      | {
           __typename?: 'SearchAndMonitoringAccessControlConfigNotFound'
           message?: string | null
        }
      | { __typename?: 'UserAuthorityNotFound'; message?: string | null }
      | { __typename?: 'UserDesignationNotFound'; message?: string | null }
      | {
           __typename?: 'UserOrganizationLevelNotFound'
           message?: string | null
        }
}

export const GetSearchAndMonitoringConfigDocument = gql`
   query GetSearchAndMonitoringConfig {
      getSearchAndMonitoringConfig {
         ... on GetSearchAndMonitoringConfigResult {
            fields {
               fieldId
               name
               fieldType
               options
               dependentOptions {
                  parentFieldId
                  optionsMappings {
                     parentFieldOption
                     dependentOptions
                  }
               }
               parentFieldId
               optionConfigs {
                  option
                  pipelineItemTemplateId
               }
               pipelineItemTemplateFields {
                  pipelineItemTemplateId
                  field {
                     ... on IntegerField {
                        ...IntegerField_Fragment
                     }
                     ... on FloatField {
                        ...FloatField_Fragment
                     }
                     ... on EmailField {
                        ...EmailField_Fragment
                     }
                     ... on FileUploaderField {
                        ...FileUploaderField_Fragment
                     }
                     ... on LongTextField {
                        ...LongTextField_Fragment
                     }
                     ... on PlainTextField {
                        ...PlainTextField_Fragment
                     }
                     ... on ShortTextField {
                        ...ShortTextField_Fragment
                     }
                     ... on URLField {
                        ...URLField_Fragment
                     }
                     ... on TimeField {
                        ...TimeField_Fragment
                     }
                     ... on DateField {
                        ...DateField_Fragment
                     }
                     ... on DateTimeField {
                        ...DateTimeField_Fragment
                     }
                     ... on DropdownField {
                        ...DropdownField_Fragment
                        conditionalOptions {
                           parentFieldId
                           options {
                              parentFieldOption
                              options
                           }
                        }
                     }
                     ... on MultiSelectField {
                        ...MultiSelectField_Fragment
                        conditionalOptions {
                           parentFieldId
                           options {
                              parentFieldOption
                              options
                           }
                        }
                     }
                     ... on CheckboxGroupField {
                        ...CheckboxGroupField_Fragment
                     }
                     ... on RadioGroupField {
                        ...RadioGroupField_Fragment
                     }
                     ... on PhoneNumberField {
                        ...PhoneNumberField_Fragment
                     }
                     ... on FieldsSelectorField {
                        ...FieldsSelectorField_Fragment
                     }
                     ... on GeoLocationField {
                        ...GeoLocationField_Fragment
                     }
                     ... on GeoShapeField {
                        ...GeoShapeField_Fragment
                     }
                  }
               }
            }
            overviewFieldIds
            filterFields {
               fieldId
               operators
            }
         }
         ... on SearchAndMonitoringAccessControlConfigNotFound {
            message
         }
         ... on UserAuthorityNotFound {
            message
         }
         ... on UserOrganizationLevelNotFound {
            message
         }
         ... on UserDesignationNotFound {
            message
         }
      }
   }
   ${IntegerField_FragmentFragmentDoc}
   ${FloatField_FragmentFragmentDoc}
   ${EmailField_FragmentFragmentDoc}
   ${FileUploaderField_FragmentFragmentDoc}
   ${LongTextField_FragmentFragmentDoc}
   ${PlainTextField_FragmentFragmentDoc}
   ${ShortTextField_FragmentFragmentDoc}
   ${UrlField_FragmentFragmentDoc}
   ${TimeField_FragmentFragmentDoc}
   ${DateField_FragmentFragmentDoc}
   ${DateTimeField_FragmentFragmentDoc}
   ${DropdownField_FragmentFragmentDoc}
   ${MultiSelectField_FragmentFragmentDoc}
   ${CheckboxGroupField_FragmentFragmentDoc}
   ${RadioGroupField_FragmentFragmentDoc}
   ${PhoneNumberField_FragmentFragmentDoc}
   ${FieldsSelectorField_FragmentFragmentDoc}
   ${GeoLocationField_FragmentFragmentDoc}
   ${GeoShapeField_FragmentFragmentDoc}
`
export type GetSearchAndMonitoringConfigQueryResult = Apollo.QueryResult<
   GetSearchAndMonitoringConfigQuery,
   GetSearchAndMonitoringConfigQueryVariables
>
